import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CommonModule } from "@angular/common";
import { NgbModule, NgbNavModule } from "@ng-bootstrap/ng-bootstrap";
import { AppRoutingModule } from "./app-routing.module";
import { SharedModule } from "./shared/shared.module";
import { ToastrModule } from "ngx-toastr";
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { StoreModule } from "@ngrx/store";
import { MapUtilityScreenComponent } from './uploadfile/modals/maputility.screen.component';
//import { MapDataUtilityScreenComponent } from './uploadfile/modals/mapdatautility.screen.component';
import { UploadNewFileScreenComponent } from './uploadfile/modals/uploadnewfile.screen.component';
import { ManageRegionScreenComponent } from './regions/modals/manageregion.screen.component';
import { AssignRegionScreenComponent } from './territories/modals/assignregion.screen.component';
import { NoteScreenComponent } from './uploadfile/modals/note.screen.component';
import { EditRuleScreenComponent } from './salespeople/modals/editrule.screen.component';
import { EditBonusRuleScreenComponent } from './salespeople/modals/editbonusrule.screen.component';
import { ActivateRuleScreenComponent } from './salespeople/modals/activaterule.screen.component';
import { CommissionDetailScreenComponent } from './commission/modals/commissiondetail.screen.component';
import { EditAdjustmentScreenComponent } from './commission/modals/editadjustment.screen.component';
import { EditSAdjustmentScreenComponent } from './salespeople/modals/editadjustment.screen.component';
import { EditSalaryDrawScreenComponent } from './salespeople/modals/editsalarydraw.screen.component';
import { EditGuaranteeScreenComponent } from './salespeople/modals/editguarantee.screen.component';
import { AddSecondaryEmailScreenComponent } from './salespeople/modals/addsecondaryemail.screen.component';
import { CalculateCommissionHistoryComponent } from './commission/modals/calculatecommissionhistory.screen.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NotifierModule } from 'angular-notifier';
import { NgxSpinnerModule } from "ngx-spinner";
import { ConfigService } from './core/config';
import { HelperService } from './core/helper';
import { NgSelectModule } from '@ng-select/ng-select';
import { EditProfileScreenComponent } from './user/modals/editprofile.screen.component';
import { CookieService } from 'ngx-cookie-service';
import { NgChartsModule } from 'ng2-charts';
import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';
import { UserService } from "./user/user.service";
import {ShowRuleAdjustmenthistoryScreenComponent} from "./salespeople/modals/showruleadjustmenthistory.screen.component"
import {ShowDrawGuaranteehistoryScreenComponent} from "./salespeople/modals/showdrawguaranteehistory.screen.component";
import {UploadNewAdjustmentFileScreenComponent} from "./upload-adjustmentfile/modals/upload-newadjustmentfile.screen.component";
import { AdjustmentNoteScreenComponent } from './upload-adjustmentfile/modals/adjustmentnote.screen.component';
import { AssignChildProcedureScreenComponent } from './procedures/modals/assignchildprocedure.screen.component';
import { ManageProcedureScreenComponent } from './procedures/modals/manageprocedure.screen.component';
//import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {AuthInterceptor} from './auth-interceptor';
import { GoogleMapsModule } from '@angular/google-maps';


const token = localStorage.getItem('accessToken');

const appConfigService = new ConfigService();
const config: SocketIoConfig = {
  url: appConfigService.socketUrl,
  options: {
    transports: ['websocket', 'polling'],
    query: {
      token: token || ''
    }
  }
};


//import { SelectDropDownModule } from 'ngx-select-dropdown'

import { AppComponent } from "./app.component";
import { ContentLayoutComponent } from "./layouts/content/content-layout.component";
import { FullLayoutComponent } from "./layouts/full/full-layout.component";

import { DragulaService } from "ng2-dragula";
import { AuthService } from "./shared/auth/auth.service";
import { AuthGuard } from "./shared/auth/auth-guard.service";

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}


@NgModule({ declarations: [AppComponent, FullLayoutComponent, ContentLayoutComponent,
        MapUtilityScreenComponent, UploadNewFileScreenComponent, NoteScreenComponent,
        EditRuleScreenComponent, EditBonusRuleScreenComponent, ActivateRuleScreenComponent, CommissionDetailScreenComponent, CalculateCommissionHistoryComponent, EditAdjustmentScreenComponent, EditSAdjustmentScreenComponent, EditSalaryDrawScreenComponent, EditProfileScreenComponent, AssignRegionScreenComponent, ManageRegionScreenComponent,
         AddSecondaryEmailScreenComponent, EditGuaranteeScreenComponent, ShowRuleAdjustmenthistoryScreenComponent, ShowDrawGuaranteehistoryScreenComponent, UploadNewAdjustmentFileScreenComponent, AdjustmentNoteScreenComponent,AssignChildProcedureScreenComponent,ManageProcedureScreenComponent],
    bootstrap: [AppComponent],
    exports: [MapUtilityScreenComponent, UploadNewFileScreenComponent, NoteScreenComponent, EditRuleScreenComponent, EditBonusRuleScreenComponent,
        ActivateRuleScreenComponent, CommissionDetailScreenComponent, EditAdjustmentScreenComponent,
        EditSalaryDrawScreenComponent, EditProfileScreenComponent, AssignRegionScreenComponent, ManageRegionScreenComponent, AddSecondaryEmailScreenComponent, EditGuaranteeScreenComponent, UploadNewAdjustmentFileScreenComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [NgChartsModule,
        NgxSpinnerModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatInputModule,
        MatSlideToggleModule,
        MatFormFieldModule,
        NotifierModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        StoreModule.forRoot({}),
        AppRoutingModule,
        SharedModule,
        NgSelectModule,
        CommonModule,
        NgbNavModule,
        // OwlDateTimeModule,
        //OwlNativeDateTimeModule,
        // SelectDropDownModule,
        ToastrModule.forRoot(),
        NgbModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            }
        }),
        GoogleMapsModule,
        SocketIoModule.forRoot(config)], providers: [
        CookieService,
        ConfigService,
        HelperService,
        AuthService,
        AuthGuard,
        DragulaService,
        UserService,
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
